import { DoughnutController, Chart } from 'chart.js'
import { each } from 'chart.js/helpers'

function clipArc(ctx, element, endAngle) {
    const {startAngle, pixelMargin, x, y, outerRadius, innerRadius} = element
    let angleMargin = pixelMargin / outerRadius

    // Draw an inner border by clipping the arc and drawing a double-width border
    // Enlarge the clipping arc by 0.33 pixels to eliminate glitches between borders
    ctx.beginPath()
    ctx.arc(x + 40, y + 40, outerRadius, startAngle - angleMargin, endAngle + angleMargin)
    if (innerRadius > pixelMargin) {
      angleMargin = pixelMargin / innerRadius
      ctx.arc(x, y, innerRadius, endAngle + angleMargin, startAngle - angleMargin, true)
    } else {
      ctx.arc(x, y, pixelMargin, endAngle + Math.PI / 2, startAngle - Math.PI / 2)
    }
    ctx.closePath()
    ctx.clip()
  }

function drawFullCircleBorders(ctx, element, inner) {
    const {x, y, startAngle, pixelMargin, fullCircles} = element
    const outerRadius = Math.max(element.outerRadius - pixelMargin, 0)
    const innerRadius = element.innerRadius + pixelMargin

    let i

    if (inner) {
      clipArc(ctx, element, startAngle + Math.PI * 2)
    }

    ctx.beginPath()
    ctx.arc(x, y, innerRadius, startAngle + Math.PI * 2, startAngle, true)
    for (i = 0; i < fullCircles; ++i) {
      ctx.stroke()
    }

    ctx.beginPath()
    ctx.arc(x, y, outerRadius, startAngle, startAngle + Math.PI * 2)
    for (i = 0; i < fullCircles; ++i) {
      ctx.stroke()
    }
  }

class SuperDuperDoughnutChart extends DoughnutController {
    draw(ease) {
        var ctx = this.chart.ctx
        var easingDecimal = ease || 1
        var arcs = this.getMeta().data

        each(arcs, function (arc, i) {
            arc.draw(ctx)
            // debugger;

            var pArc = arcs[i === 0 ? arcs.length - 1 : i - 1]
            var pColor = pArc.options.backgroundColor

            var vm = arc
            var radius = (vm.outerRadius + vm.innerRadius) / 2
            var thickness = (vm.outerRadius - vm.innerRadius) / 2
            var startAngle = Math.PI - vm.startAngle - Math.PI / 2
            var angle = Math.PI - vm.endAngle - Math.PI / 2

            ctx.save()
            ctx.translate(vm.x, vm.y)
            ctx.fillStyle = i === 0 ? vm.options.backgroundColor : pColor
            ctx.beginPath()
            ctx.arc(radius * Math.sin(startAngle), radius * Math.cos(startAngle), thickness, 0, 2 * Math.PI)
            ctx.fill()

            ctx.fillStyle = vm.options.backgroundColor
            ctx.beginPath()
            ctx.arc(radius * Math.sin(angle), radius * Math.cos(angle), thickness, 0, 2 * Math.PI)
            ctx.fill()

            ctx.restore()
            // ctx.fillStyle = "black";
            // drawFullCircleBorders(ctx, arc, false);
        })
    }
}

SuperDuperDoughnutChart.id = 'SuperDuperDoughnutChart'
SuperDuperDoughnutChart.defaults = DoughnutController.defaults

export default SuperDuperDoughnutChart
